export default {
    CANNOT_ACCESS_LOOTBAG: 'You cannot access this lootbag right now.',
    REQUIRES_ACHIEVEMENT: 'This item requires a secret achievement to equip.',
    REQUIRES_QUEST: 'You must complete {{quest}} to equip this item.',
    SKILL_LEVEL_REQUIREMENT_EQUIP: 'Your {{skill}} must be at least level {{level}} to equip this.',
    TOTAL_LEVEL_REQUIREMENT: 'Your total level must be at least {{level}} to equip this item.'
} as const;
